<template>
  <div id="app">
    <component :is="layout">
      <transition name="slide-fade" mode="out-in">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </component>
  </div>
</template>

<script>
import RouteGetters from '@/mixins/RouteGetters'

export default {
  mixins: [RouteGetters],
  computed: {
    layout: function () {
      const layout = typeof this.route.meta.layout !== 'undefined'
        ? `${this.route.meta.layout}-layout`
        : `default-layout`

      return layout
    }
  }
}
</script>

<style lang="scss" scoped></style>
